import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {PreferencesComponent} from './preferences.component';
import {PreferencesDeactivationGuard} from './preferences-deactivation-guard.service';
import {PreferencesPath} from '../navigation/routes';
import {InvestmentPreferencesResolver} from '../resolvers/investment-preferences.resolver';
import { ProductResolver } from '../resolvers/product.resolver';

const routes: Routes = [{
    path: PreferencesPath,
    pathMatch: 'full',
    component: PreferencesComponent,
    resolve: {
        investmentPreferences: InvestmentPreferencesResolver,
        product: ProductResolver
    },
    canDeactivate: [PreferencesDeactivationGuard]
}];

@NgModule({
    imports: [RouterModule.forChild(routes)]
})
export class PreferencesRoutingModule {
}
